import sendComment from '@/ajax/shop/article/send-comment';

export default sendComment;
